
import {
  computed, defineComponent, reactive,
} from 'vue';
import { IPedidoCompra } from '@/models/Entidades/Compras/IPedidoCompra';

export default defineComponent({
  name: 'PedidoCompraDadosAdicionais',
  props: {
    notaFiscal: {
      type: Object as () => IPedidoCompra,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
  },
  components: {
  },
  emits: ['update:notaFiscal', 'campoAlterado'],
  setup(props, { emit }) {
    const state = reactive({});

    const computedPedidoCompra = computed({
      get: () => props.notaFiscal,
      set: (val: IPedidoCompra) => {
        emit('update:notaFiscal', val);
      },
    });

    function campoAlterado(campo: string) {
      emit('campoAlterado', campo);
    }

    return {
      props,
      state,
      computedPedidoCompra,
      campoAlterado,
    };
  },
});
